import React from 'react';
import { Popover, Tag } from 'antd';
// import { type IClickableElement } from '../../../hooks/useSocket__';
import { StyledClickableElement } from './styles';
import { MappingRulesRender } from '@src/emp-3.0/components/MappedEventDetail';
import { evaluateRules } from './validateRule';

function toDisplayName(camelCase: string): string {
  return camelCase
    .replace(/([a-z])([A-Z])/g, '$1 $2') // insert space before capital letters
    .replace(/^./, (s) => s.toUpperCase()); // capitalize first letter
}

const MATCHED_HIGHLIGHT_COLOR = [
  '#01a801', // border
  'rgba(0,255,10,0.5)', // background-color
];

const UNMATCHED_HIGHLIGHT_COLOR = [
  '#FFB800', // border
  'rgba(255, 184, 0, 0.50)', // background-color
];

const ClickableElement = ({
  element,
  onClick,
  highlight = false,
  allMappedEvents = [],
  scaleFactor = 1,
}: {
  element: any;
  highlight?: boolean;
  onClick?: (v: any) => void;
  allMappedEvents: any[];
  scaleFactor?: number;
}) => {
  const content = (
    <div>
      {Object.entries(element)
        .filter(([key]) => key !== 'frame')
        .map(([key, value]) => (
          <div key={key}>
            <span style={{ marginRight: 5 }}>{toDisplayName(key)}: </span>
            <span style={{ color: '#686767' }}>{value}</span>
          </div>
        ))}
    </div>
  );

  const numbers = element.frame.match(/-?\d+(\.\d+)?/g)?.map(Number);

  const [left, top, width, height] = numbers || [0, 0, 0, 0];

  // Apply scale factor to position and dimensions
  const scaledLeft = left * scaleFactor;
  const scaledTop = top * scaleFactor;
  const scaledWidth = width * scaleFactor;
  const scaledHeight = height * scaleFactor;

  const mappedEvent = allMappedEvents.find((event) => {
    return evaluateRules(element, event.rules);
  });

  return (
    <Popover
      placement="right"
      content={mappedEvent ? <MappingRulesRender rules={mappedEvent.rules} /> : content}
      title={
        mappedEvent ? (
          <div>
            {mappedEvent.event_name}{' '}
            <Tag color="green" style={{ marginLeft: 5 }}>
              Mapped
            </Tag>
          </div>
        ) : (
          <div>
            {element.elementType} <Tag style={{ marginLeft: 5 }}>Raw</Tag>
          </div>
        )
      }
    >
      <StyledClickableElement
        $width={scaledWidth}
        $height={scaledHeight}
        $top={scaledTop}
        $left={scaledLeft}
        $borderColor={mappedEvent ? MATCHED_HIGHLIGHT_COLOR[0] : UNMATCHED_HIGHLIGHT_COLOR[0]}
        $background={
          highlight ? (mappedEvent ? MATCHED_HIGHLIGHT_COLOR[1] : UNMATCHED_HIGHLIGHT_COLOR[1]) : ''
        }
        onClick={() =>
          onClick?.(
            mappedEvent
              ? {
                  type: 'update',
                  mappedEvent,
                }
              : {
                  type: 'create',
                  eventName: `conviva_${element.elementType}_click`,
                  eventAttributes: element,
                },
          )
        }
      />
    </Popover>
  );
};

export default ClickableElement;
